{
  "tabs": {
    "chat": "Colloquium",
    "reminders": "Monita",
    "calendar": "Calendarium",
    "settings": "Optiones"
  },
  "common": {
    "cancel": "Rēspuāre",
    "save": "Servāre",
    "confirm": "Confīrmāre",
    "delete": "Dēlēre",
    "back": "Retro",
    "close": "Claudere",
    "edit": "Editāre",
    "search": "Quaerere",
    "all": "Omnia",
    "loading": "Onere...",
    "error": "Aliquid errātum est",
    "notFound": "Non inventum",
    "tryAgain": "Iterum tenta",
    "retry": "Iterāre",
    "undo": "Revocāre",
    "pullToRefresh": "Trahe ad renovandum",
    "justNow": "nūper"
  },
  "auth": {
    "welcome": "Grātulāmur ad FishMemory",
    "tagline": "Tuum WhatsApp adiūtōrem monitōrum, nunc in sinū tuo.",
    "subtitle": "Tuum WhatsApp adiūtōrem monitōrum, nunc in sinū tuo.",
    "phoneLabel": "Numerus tuus WhatsApp",
    "phoneHint": "Codicem verificātiōnis per WhatsApp mittēmus",
    "invalidPhone": "Numerum validum insere",
    "continue": "Pergere",
    "enterPhone": "Insere numerum tuum WhatsApp",
    "phonePlaceholder": "Numerus telephonicus",
    "sendCode": "Mitte Codicem",
    "verifyTitle": "Verificā numerum",
    "otpSentTo": "Codex sex digitorum ad {{phone}} per WhatsApp missus est",
    "enterFullCode": "Omnes sex digitos insere",
    "invalidOtp": "Codex invalidus. Iterum tenta.",
    "otpFailed": "Codicem mittere non potuimus. Iterum tenta.",
    "otpResent": "Codex iterum missus",
    "resendIn": "Iterum mitte in {{seconds}}s",
    "resendCode": "Iterum mitte codicem",
    "enterOtp": "Insere codicem ad WhatsApp missum",
    "verify": "Verificā",
    "resend": "Iterum mitte codicem",
    "wrongNumber": "Numerus errātus?",
    "backToPhone": "Retro ad numerum",
    "editPhone": "Mutā numerum",
    "error": "Error",
    "setupTitle": "Constituāmus",
    "setupSubtitle": "Semper potes haec mutāre in Optionibus",
    "namePlaceholder": "Nomen tuum",
    "letsGo": "Confīrmā",
    "skipForNow": "Nunc praetereā"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Scribe nūntium...",
    "inputPlaceholder": "Scribe nūntium...",
    "typing": "FishMemory scrībit...",
    "online": "In līneā",
    "connecting": "Connēctit...",
    "reconnecting": "Reconectit...",
    "offline": "Extrā līneam",
    "empty": "Incipe colloquium",
    "emptyHint": "Creā monita, vide schedulam, aut pete auxilium.",
    "emptyAction": "Mitte exemplum monitī",
    "actions": "Actionēs colloquī",
    "keep": "Servā nūntiōs",
    "clearTitle": "Purgā colloquium",
    "clearConfirm": "Dēlē omnēs nūntiōs hīc? Hoc non revocābitur.",
    "clear": "Purgā colloquium",
    "optionSelected": "Electum: {{label}}",
    "sendingSelection": "Mittitur...",
    "connectionLost": "Reconectit..."
  },
  "reminders": {
    "title": "Mea Monita",
    "active": "Actīva",
    "today": "Hodiē",
    "thisWeek": "Hāc Septimānā",
    "history": "Historia",
    "items": "rēs",
    "emptyTitle": "Nūlla monita adhūc",
    "emptySubtitle": "Crea ex colloquiō et hic apparebit.",
    "emptyAction": "Aperi colloquium",
    "filterActive": "Actīva",
    "filterToday": "Hodiē",
    "filterWeek": "Hāc Septimānā",
    "filterHistory": "Historia",
    "emptyState": "Nūlla monita adhūc. Incipī colloquium!",
    "swipeDone": "Factum",
    "swipeSnooze": "Posticipā",
    "swipeDelete": "Dēlē",
    "search": "Quaere monita...",
    "upcoming": "Futūra",
    "completed": "Complēta",
    "overdue": "Praeterita",
    "tomorrow": "Crās",
    "synced": "Synchronizātum {{value}}",
    "swipeHint": "Trahe monitum pro plūribus actiōnibus",
    "noResults": "Nūlla monita quaerentī conveniunt",
    "noResultsHint": "Tenta aliud verbum aut purga quaerentem",
    "deleteAllFailed": "Dēlēre omnia monita nōn potuit"
  },
  "calendar": {
    "title": "Calendarium",
    "today": "Hodiē",
    "tomorrow": "Crās",
    "completed": "factum",
    "noEvents": "Nihil prōpositum",
    "noEventsSubtitle": "Eligere diem ut videās monita et eventūs calendarii.",
    "googleEvent": "Google Calendarium",
    "legendActive": "Actīva",
    "legendRecurring": "Recurrēns",
    "legendDone": "Factum",
    "legendGoogle": "Google",
    "previousMonth": "Mēnsis praeteritus",
    "nextMonth": "Mēnsis prōximus",
    "previousYear": "Annus praeteritus",
    "nextYear": "Annus prōximus",
    "goToToday": "Ad hodiē ī",
    "all": "Omnia",
    "active": "Actīva",
    "done": "Facta",
    "paused": "Intermissum"
  },
  "settings": {
    "title": "Optiōnēs",
    "profile": "Profilum",
    "name": "Nomen ostendendum",
    "enterName": "Insere nomen",
    "language": "Linguā",
    "uiLanguage": "Linguā app",
    "uiLanguageHelp": "Mutat linguam interfaciei, titulos calendarii, et ordinem layout tantum in hōc dispositīvō.",
    "serverLanguage": "Linguā colloquī",
    "serverLanguageHelp": "Mutat linguam responsionum servitōris et nūntiōrum monitōrum pro ratiōne tua.",
    "timezone": "Zona temporis",
    "currentTimezone": "Zona temporis nunc",
    "timezoneHelp": "Omnēs hōrae monitōrum hāc zonā temporis monstrantur.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Servā zonam temporis",
    "timezoneSaved": "Zona temporis adēpta",
    "detect": "Dētege",
    "detectFailed": "Zona temporis dētegi nōn potuit",
    "autoDetect": "Automatice dētege ex GPS",
    "notifications": "Nūntiātiōnēs",
    "notificationsHelp": "Monita repetita post primum monitum reguntur. Permissiōnēs nūntiātiōnum in dispositīvō adhūc geruntur in optiōnibus telephonī.",
    "pushEnabled": "Nūntiātiōnēs push",
    "autoDoneOnFire": "Automatice signā factum cum excitātum",
    "autoDoneOnFireDesc": "Sī off, monita actīva manent donec ipsōs signēs.",
    "googleCalendar": "Google Calendarium",
    "google": "Google Calendarium",
    "googleConnected": "Connēctum",
    "googleDisconnected": "Non connēctum",
    "googleConnectedHelp": "Novī monita synchronizārī possunt ad calendarium tuum automatice.",
    "googleDisconnectedHelp": "Coniunge Google Calendarium ut monita et eventūs congruant.",
    "googleConnectFailed": "Coniungere Google Calendarium nōn potuit",
    "connected": "Connēctum",
    "disconnected": "Non connēctum",
    "connect": "Coniunge",
    "disconnect": "Disconiunge",
    "autoSync": "Automatice synchronizā novōs monitōs",
    "autosync": "Automatice synchronizā novōs monitōs",
    "subscription": "Subscriptiō",
    "trialUsed": "Probātiō: {{used}}/{{total}} ūsa",
    "trialStatus": "Probātiō praesto",
    "activeStatus": "Subscriptiō actīva",
    "expiredStatus": "Subscriptiō expīrāta",
    "unsubscribedStatus": "Non subscriptus",
    "about": "De",
    "version": "Versiō",
    "logout": "Exīre",
    "logoutTitle": "Exīre",
    "logoutConfirm": "Certus es tē exīre velle?",
    "noName": "Nomen nōn datum",
    "serverConnection": "Connexiō servitōris",
    "serverUrl": "URL servitōris",
    "serverEdit": "Editāre",
    "saveReconnect": "Servā et reconnēctere",
    "resetDefault": "Restitue prōpositum",
    "invalidServerUrlTitle": "URL servitōris invalidum",
    "invalidServerUrlMessage": "Insere validum URL servitōris http vel https, exempli gratiā https://example.com",
    "uiLanguageChangeFailed": "Mutāre linguam app nōn potuit. Iterum tenta.",
    "serverLanguageChangeFailed": "Mutāre linguam colloquī nōn potuit. Iterum tenta.",
    "timezoneChangeFailed": "Mutāre zonam temporis nōn potuit. Iterum tenta.",
    "autoSyncChangeFailed": "Mutāre synchronizātiōnem automatam nōn potuit. Iterum tenta.",
    "nameChangeFailed": "Mutāre nomen ostentandum nōn potuit. Iterum tenta.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Rēs monitōris",
    "editTime": "Tempus editāre",
    "rename": "Renomināre",
    "snooze": "Posticipā",
    "snooze15": "Posticipā 15 minūtīs",
    "pause": "Intermitte",
    "pauseReminder": "Monitum intermitte",
    "resume": "Pergere",
    "resumeReminder": "Monitum perge",
    "skip": "Praeteri Occāsiōnem",
    "skipOccurrence": "Praeteri hanc occāsiōnem",
    "syncGoogle": "Synchronizā ad Google",
    "delete": "Dēlē",
    "deleteTitle": "Dēlē Monitum",
    "deleteConfirm": "Hic monitum dēlēbitur in perpetuum.",
    "deleteRecurringTitle": "Dēlē Monitum Recurrēns",
    "deleteRecurringMessage": "Visne hanc occāsiōnem praeterīre an totam seriem dēlēre?",
    "deleteThisOccurrence": "Praeteri hanc occāsiōnem",
    "deleteEntireSeries": "Dēlē totam seriem",
    "done": "Factum",
    "markDone": "Signā ut factum",
    "undo": "Restitue",
    "undoPrompt": "Opus est ut iterum activum sit? Nunc restituē.",
    "recurring": "Recurrēns",
    "nextRun": "Proximum cursum",
    "oneTime": "Semel",
    "pending": "Exspectāns",
    "sent": "Missum",
    "paused": "Intermissum",
    "active": "Actīvum",
    "snoozed": "Posticipātum",
    "localTime": "Monstrātur in hōrā localī",
    "recurrence": "Recurrēntia",
    "created": "Creatum",
    "tags": "Signa",
    "fireCount": "Vices excitātum",
    "actions": "Actiōnēs",
    "none": "Nihil",
    "snoozeFailed": "Posticipāre monitum nōn potuit",
    "pauseFailed": "Intermittere monitum nōn potuit",
    "resumeFailed": "Pergere monitum nōn potuit",
    "skipFailed": "Praeterīre monitum nōn potuit",
    "doneFailed": "Signāre monitum ut factum nōn potuit",
    "undoFailed": "Restituere statum monitōris nōn potuit",
    "deleteFailed": "Dēlēre monitum nōn potuit",
    "rescheduleTitle": "Iterum constituere?",
    "rescheduleMsg": "Hic monitum praeāctum est. Visne iterum constituere?",
    "reschedule15": "In 15 minūtīs",
    "reschedule60": "In 1 hōrā",
    "keepOverdue": "Sīcut est servā"
  },
  "onboarding": {
    "slide1Title": "Grātulāmur ad FishMemory",
    "slide1Sub": "Tuum adiūtōrem monitōrum persōnālem — per WhatsApp et ad sinum tuum factum.",
    "slide2Title": "Simpliciter Colloquere",
    "slide2Sub": "Scribe monitōs ut cogitās: \"Mone mē crās ad 3 post merīdiem mātrem vocāre\" — cēterum gerimus.",
    "slide3Title": "Nē umquam Rēmīttās",
    "slide3Sub": "Accipe nūntiātiōnēs tempestīvās, ordina cum signīs, et tene omnia quae important.",
    "getStarted": "Incipe",
    "next": "Sequēns",
    "firstReminderTitle": "Crea prīmum monitum!",
    "firstReminderHint": "Tenta scribere aliquid simile:",
    "firstReminderExample": "Mone mē aquam bibere crās ad 9 AM",
    "gotIt": "Intellēxī!",
    "notifRationaleTitle": "Mane Tempestīvus",
    "notifRationaleBody": "FishMemory nūntiātiōnēs opus habet ut tē tempestīve moneat. Tantum monitōrum tuōrum nūntiātiōnēs accipiēs.",
    "notifRationaleAllow": "Permitte Nūntiātiōnēs",
    "notifRationaleLater": "Forsitan Pōst",
    "swipeHint": "Trahe dextrō ad actiōnēs celerēs →",
    "calendarDragHint": "Trahe ad extendendum ↕"
  }
}
